import d, { createContext as c, useContext as m } from "react";
import { useEvent as p } from '../hooks/use-event.js';
import { useIsoMorphicEffect as f } from '../hooks/use-iso-morphic-effect.js';
var a = c(function () {});
a.displayName = "StackContext";
var s = function (e) {
  return e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e;
}(s || {});
function x() {
  return m(a);
}
function b(_ref) {
  var i = _ref.children,
    r = _ref.onUpdate,
    e = _ref.type,
    n = _ref.element,
    u = _ref.enabled;
  var l = x(),
    o = p(function () {
      r == null || r.apply(void 0, arguments), l.apply(void 0, arguments);
    });
  return f(function () {
    var t = u === void 0 || u === !0;
    return t && o(0, e, n), function () {
      t && o(1, e, n);
    };
  }, [o, e, n, u]), d.createElement(a.Provider, {
    value: o
  }, i);
}
export { s as StackMessage, b as StackProvider, x as useStackContext };